import * as React from "react";
import { forwardRef } from "react";
const SvgRightChevron = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" ref={ref} {...props}><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" /></svg>;
const ForwardRef = forwardRef(SvgRightChevron);
export default ForwardRef;